import { createContext } from "react";

export const SiteContext = createContext({
  loading: true,
  site: {},
  setSite: () => {},
  reloadSettings: () => {},
});
